import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import useSchemaTests from "../hooks/useSchemaTests";
import { useController } from "react-hook-form";

export const FormTextField = (props) => {
  const {
    control,
    name,
    label,
    value,
    schema,
    required,
    readOnly,
    helperText,
    inputProps,
    InputProps,
    error,
    formErrors,
    onChange,
    inputRef,
    shrink,
    ...rest
  } = props;

  const { field } = useController({ name, control });

  const [localValue, setLocalValue] = useState("");

  const [schemaRequired, schemaMaxLengthValue] = useSchemaTests(schema);

  const iProps = {
    ...inputProps,
    ...(schemaMaxLengthValue && { maxLength: schemaMaxLengthValue }),
  };

  const IProps = {
    ...InputProps,
    ...(readOnly && { readOnly: true }),
  };

  useEffect(() => {
    if (onChange) onChange(value);
  }, [value, onChange]);

  useEffect(() => {
    if (value !== undefined) setValue(value);
  }, [value]);

  const setValue = (value) => {
    if (label === 'Usuario' || schema.label === 'Usuario' && value.includes(" ")) return
    field.onChange(value);
    setLocalValue(value);
  };

  return (
    <TextField
      name={name}
      value={localValue}
      label={label || schema?.label}
      InputLabelProps={{
        required: required !== undefined ? required : schemaRequired,
        shrink
      }}
      InputProps={IProps}
      inputProps={iProps}
      error={error !== undefined ? error : !!formErrors}
      helperText={helperText || formErrors?.message}
      onChange={(e) => setValue(e.target.value)}
      {...rest}
    />
  );
};
